var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1287,
    height: 780,
    viewBox: "0 0 1287 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 822.822,
    cy: 338.05,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.694,
    cy: 252.167,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.789,
    cy: 212.087,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66998,
    cy: 440.635,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.976,
    cy: 498.846,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.275,
    cy: 30.7749,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.1276,
    cy: 458.29,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1243.65,
    cy: 215.904,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1155.86,
    cy: 380.993,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.45,
    cy: 716.42,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.8301,
    cy: 176.33,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145.84,
    cy: 142.902,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1066.26,
    cy: 304.764,
    r: 2.62425,
    transform: "rotate(78.2376 1066.26 304.764)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.155,
    cy: 203.021,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.353,
    cy: 483.1,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.816,
    cy: 401.51,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.9,
    cy: 522.702,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669.185,
    cy: 237.853,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 934.469,
    cy: 564.213,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7291,
    cy: 535.585,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881.987,
    cy: 543.219,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.658,
    cy: 712.603,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.76,
    cy: 104.732,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 953.743,
    cy: 283.503,
    r: 2.62425,
    transform: "rotate(78.2376 953.743 283.503)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.701,
    cy: 235.944,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 763.658,
    cy: 472.603,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.604,
    cy: 282.703,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.9998,
    cy: 341.868,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.522,
    cy: 241.67,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.307,
    cy: 578.807,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 798.965,
    cy: 776.061,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690.178,
    cy: 210.178,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603.686,
    cy: 641.064,
    r: 2.14711,
    transform: "rotate(172.656 603.686 641.064)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1284.21,
    cy: 15.0294,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.6594,
    cy: 62.7434,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.398,
    cy: 430.138,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.292,
    cy: 348.071,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1105.76,
    cy: 766.996,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1285.17,
    cy: 407.235,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.39,
    cy: 75.6268,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872.826,
    cy: 193.329,
    r: 3.10138,
    transform: "rotate(78.2376 872.826 193.329)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.959,
    cy: 653.458,
    r: 3.10138,
    transform: "rotate(165 261.959 653.458)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 894.393,
    cy: 535.585,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.49,
    cy: 63.2202,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.107,
    cy: 168.071,
    r: 1.19284,
    transform: "rotate(78.2376 972.107 168.071)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.107,
    cy: 365.071,
    r: 1.19284,
    transform: "rotate(78.2376 972.107 365.071)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.289,
    cy: 659.514,
    r: 1.19284,
    transform: "rotate(165 287.289 659.514)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.05,
    cy: 582.822,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.119,
    cy: 629.581,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.953,
    cy: 519.363,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.08,
    cy: 47.4747,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.023,
    cy: 2.62425,
    r: 2.62425,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.676,
    cy: 109.025,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 771.832,
    cy: 721.383,
    r: 3.10138,
    transform: "rotate(172.656 771.832 721.383)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.397,
    cy: 57.4948,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.221,
    cy: 366.201,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1232.2,
    cy: 123.339,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1007.35,
    cy: 188.853,
    r: 1.19284,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.746,
    cy: 109.025,
    r: 3.10138,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.633,
    cy: 750.535,
    r: 3.10138,
    transform: "rotate(172.656 545.633 750.535)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.147,
    cy: 564.458,
    r: 3.10138,
    transform: "rotate(165 479.147 564.458)",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1129.62,
    cy: 405.327,
    r: 1.66998,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1001.27,
    cy: 717.851,
    r: 2.14711,
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.819 122.996C168.509 121.372 170.811 121.372 171.501 122.996L174.22 129.399C174.388 129.796 174.68 130.128 175.052 130.345L181.2 133.933C182.523 134.705 182.523 136.616 181.2 137.388L175.052 140.975C174.68 141.193 174.388 141.524 174.22 141.921L171.501 148.324C170.811 149.949 168.509 149.949 167.819 148.324L165.101 141.921C164.932 141.524 164.64 141.193 164.268 140.975L158.12 137.388C156.797 136.616 156.797 134.705 158.12 133.933L164.268 130.345C164.64 130.128 164.932 129.796 165.101 129.399L167.819 122.996Z",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.5 265.324C1197.81 266.949 1195.51 266.949 1194.82 265.324L1192.1 258.921C1191.93 258.524 1191.64 258.193 1191.27 257.975L1185.12 254.388C1183.8 253.616 1183.8 251.705 1185.12 250.933L1191.27 247.345C1191.64 247.128 1191.93 246.796 1192.1 246.399L1194.82 239.996C1195.51 238.372 1197.81 238.372 1198.5 239.996L1201.22 246.399C1201.39 246.796 1201.68 247.128 1202.05 247.345L1208.2 250.933C1209.52 251.705 1209.52 253.616 1208.2 254.388L1202.05 257.975C1201.68 258.193 1201.39 258.524 1201.22 258.921L1198.5 265.324Z",
    fill: "#F3ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.819 639.996C424.509 638.372 426.811 638.372 427.501 639.996L430.22 646.399C430.388 646.796 430.68 647.128 431.052 647.345L437.2 650.933C438.523 651.705 438.523 653.616 437.2 654.388L431.052 657.975C430.68 658.193 430.388 658.524 430.22 658.921L427.501 665.324C426.811 666.949 424.509 666.949 423.819 665.324L421.101 658.921C420.932 658.524 420.64 658.193 420.268 657.975L414.12 654.388C412.797 653.616 412.797 651.705 414.12 650.933L420.268 647.345C420.64 647.128 420.932 646.796 421.101 646.399L423.819 639.996Z",
    fill: "#F3ECEB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.6de5fc4a8e072f0f16a9bbe077b6bb24.svg";
export { ForwardRef as ReactComponent };